import React from 'react'
import loaderSvg from '../../assets/images/loader.svg'

const MiniLoader: React.FC = () => {
  return (
    <div className='mini-loader'>
      <img src={loaderSvg} alt='Loading...'/>
    </div>
  )
}

export default MiniLoader
